import { BaseApiClient } from './BaseApiClient';
import { IApiInterface } from './IApiConfig';
import { IAuthTokenBuilder } from './IAuthTokenBuilder';

export class InvitationsClient extends BaseApiClient {
  private logger: any;

  public constructor(config: IApiInterface, fetch: any, logger: any, authTokenBuilder: IAuthTokenBuilder,
                     googleAnalytics?: any) {
    super(config, fetch, authTokenBuilder, googleAnalytics);
    this.logger = logger || (() => {
      // empty
    });
  }

  public cancelInvite = async (myBookingId: string) => {
    this.logger(`[InvitationsClient] cancelling invitation for booking ${myBookingId}`);
    const request = await this.buildDeleteRequest(`api/invitations/${myBookingId}`);
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public changeInvite = async (bookingId: string, newPartnerId: string) => {
    this.logger(`[InvitationsClient] cancelling invitation for booking ${bookingId}`);
    const request = await this.buildPostRequest(`api/invitations/${bookingId}`, {
      partnerId: newPartnerId,
    });
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public acceptInvite = async (myBookingId: string, acceptInviterSettings: boolean) => {
    this.logger(`[InvitationsClient] accepting invitation for booking ${myBookingId}`);
    const request = await this.buildPostRequest(`api/invitations/${myBookingId}/acceptance`, {
      accepted: true,
      acceptInviterSettings,
    });
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public rejectInvite = async (myBookingId: string) => {
    this.logger(`[InvitationsClient] rejecting invitation for booking ${myBookingId}`);
    const request = await this.buildPostRequest(`api/invitations/${myBookingId}/acceptance`, {
      accepted: false,
    });
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }
}
